export default __webpack_public_path__ + "static/media/24_photo.418e5366.jpeg";